const swiper = new Swiper('.js-carousel-categories', {
	loop: false,
	slidesPerView: "auto",
	freeMode: true,
	spaceBetween: 6,
	autoplay: {
		delay: 2500,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		320: {
			spaceBetween: 15,
		},
		768: {
			spaceBetween: 6,
		}
	}
});

const swiper2 = new Swiper('.js-carousel-products', {
	loop: false,
	slidesPerView: "auto",
	freeMode: true,
	spaceBetween: 6,
	autoplay: {
		delay: 2500,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		320: {
			spaceBetween: 15,
		},
		768: {
			spaceBetween: 6,
		}
	}
});

const swiper3 = new Swiper('.js-relative-products-sep', {
	loop: false,
	slidesPerView: 4,
	freeMode: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.swiper-button-next-sep',
		prevEl: '.swiper-button-prev-sep',
	},
	autoplay: {
		delay: 2500,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		300: {
			spaceBetween: 15,
			slidesPerView: "auto",
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1200: {
			slidesPerView: 4,
			spaceBetween: 30,
		}
	}
});
const swiper4 = new Swiper('.js-relative-products-bef', {
	loop: false,
	slidesPerView: 4,
	freeMode: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.swiper-button-next-bef',
		prevEl: '.swiper-button-prev-bef',
	},
	autoplay: {
		delay: 2500,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		300: {
			spaceBetween: 15,
			slidesPerView: "auto",
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1200: {
			slidesPerView: 4,
			spaceBetween: 30,
		}
	}
});
const swiper5 = new Swiper('.js-relative-products-sim', {
	loop: false,
	slidesPerView: 4,
	freeMode: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.swiper-button-next-sim',
		prevEl: '.swiper-button-prev-sim',
	},
	autoplay: {
		delay: 2500,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		300: {
			spaceBetween: 15,
			slidesPerView: "auto",
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1200: {
			slidesPerView: 4,
			spaceBetween: 30,
		}
	}
});
let gallery = 0;
if ($( window ).width() < 991) {
	gallery = new Swiper('.product-gallery', {
		loop: false,
		slidesPerView: "auto",
		freeMode: true,
		spaceBetween: 15
	});
} else {
	if (gallery !== 0) {
		gallery.destroy();
	}
}
